import datepicker from "js-datepicker";

import "js-datepicker/dist/datepicker.min.css";
import "./datepicker.pcss";

export default datepicker;
